import React, { useEffect, useState } from 'react';
import { FaComments, FaSearch } from 'react-icons/fa';

export default function ChatToggle() {
  const [chatMode, setChatMode] = useState(false);

  useEffect(() => {
    // Check if localStorage is available (client-side only)
    if (typeof window !== 'undefined') {
      // Get saved preference or default to false (standard mode)
      const savedMode = localStorage.getItem('chatMode');
      setChatMode(savedMode === 'true');
    }
  }, []);

  const toggleChatMode = () => {
    const newChatMode = !chatMode;
    setChatMode(newChatMode);
    
    // Update localStorage
    if (typeof window !== 'undefined') {
      localStorage.setItem('chatMode', newChatMode.toString());
      // Dispatch an event so other components can react
      window.dispatchEvent(new Event('chatModeChange'));
    }
  };

  return (
    <div className="flex items-center">
      <span className="mr-2 text-blue-500"><FaSearch /></span>
      <label className="toggle-switch">
        <input 
          type="checkbox" 
          checked={chatMode} 
          onChange={toggleChatMode}
        />
        <span className="toggle-slider"></span>
      </label>
      <span className="ml-2 text-green-500"><FaComments /></span>
    </div>
  );
}